import md5 from 'md5';

/**
 * Determines if a value falls within a target percentage range based on its hash.
 * This can be used for consistent, deterministic partitioning of inputs.
 *
 * @param value - The string to hash (e.g., an identifier, URL, or arbitrary value)
 * @param targetPercentage - Percentage of values that should return true (0-100)
 * @returns boolean - True if the hashed value falls within the target percentage
 *
 * @example
 * // Check if value is in the first 10% of the range
 * isValueInPercentageRange('some-value', 10)
 *
 * // Partition a value deterministically into a percentage bucket
 * isValueInPercentageRange('unique-id', 50)
 */
export function isValueInPercentageRange(
  value: string,
  targetPercentage: number
): boolean {
  if (targetPercentage > 100 || targetPercentage < 0) {
    throw new Error('Target percentage must be between 0 and 100');
  }
  const hash: string = md5(value);
  const lastTwoHex = hash.slice(-2);
  const numValue = parseInt(lastTwoHex, 16);
  const actualPercentage = (numValue / 255) * 100;
  return actualPercentage <= targetPercentage;
}
